"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const offchainAccountPoolToken_1 = __importDefault(require("../offchainAccountPoolToken"));
class OffchainAccountBorrowable extends offchainAccountPoolToken_1.default {
    constructor(lendingPool, poolTokenType) {
        super();
        this.getLendingPool = () => this.lendingPool;
        this.getPoolToken = () => this.poolToken;
        this.lendingPool = lendingPool;
        this.poolTokenType = poolTokenType;
        this.poolToken = lendingPool.getLendingPool().getPoolToken(poolTokenType);
    }
    getSupplyPosition() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPoolPosition = yield this.lendingPool.getLendingPoolPosition();
            if (!lendingPoolPosition)
                return undefined;
            return lendingPoolPosition.supplyPositions[this.poolTokenType];
        });
    }
    // TODO update to support real time exchange rate
    getAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            const supplyPosition = yield this.getSupplyPosition();
            if (!supplyPosition)
                return 0;
            const exchangeRate = yield this.poolToken.getExchangeRate();
            const supplyBalance = parseFloat(supplyPosition.balance);
            return supplyBalance * exchangeRate;
        });
    }
    getBorrowPosition() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPoolPosition = yield this.lendingPool.getLendingPoolPosition();
            if (!lendingPoolPosition)
                return undefined;
            return lendingPoolPosition.borrowPositions[this.poolTokenType];
        });
    }
    getBorrowedAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            const borrowPosition = yield this.getBorrowPosition();
            const borrowIndex = yield this.poolToken.getBorrowIndex();
            if (!borrowPosition)
                return 0;
            const borrowBalance = parseFloat(borrowPosition.borrowBalance);
            const userBorrowIndex = parseFloat(borrowPosition.borrowIndex);
            return borrowBalance * borrowIndex / userBorrowIndex;
        });
    }
    getBorrowedValue() {
        return __awaiter(this, void 0, void 0, function* () {
            const tokenPrice = yield this.poolToken.getTokenPriceAccurate();
            const borrowedAmount = yield this.getBorrowedAmount();
            return borrowedAmount * tokenPrice;
        });
    }
}
exports.default = OffchainAccountBorrowable;
